<template>
  <div id="adminDashboard">
    <AdminBormacDashboard v-if="isBormac"></AdminBormacDashboard>
    <AdminSixtenDashboard v-if="isSixten"></AdminSixtenDashboard>
    <AdminLifestyleDashboard v-if="isLifestyle"></AdminLifestyleDashboard>
    <AdminPalestraReadyDashboard v-if="isPalestraReady"></AdminPalestraReadyDashboard>
    <AdminFGMAutotrasportiDashboard v-if="isFGMAutotrasporti"></AdminFGMAutotrasportiDashboard>
    <AdminMdMicrodetectorsDashboard v-if="isMdMicrodetectors"></AdminMdMicrodetectorsDashboard>
    <AdminMatteoRinaldiDashboard v-if="isMatteoRinaldi"></AdminMatteoRinaldiDashboard>
    <AdminSelenaDashboard v-if="isSelena"></AdminSelenaDashboard>
  </div>
</template>

<script>

import AdminBormacDashboard from '@/views/admin/dashboard/Bormac';
import AdminSixtenDashboard from '@/views/admin/dashboard/Sixten';
import AdminSelenaDashboard from '@/views/admin/dashboard/Selena';
import AdminLifestyleDashboard from '@/views/admin/dashboard/Lifestyle';
import AdminPalestraReadyDashboard from '@/views/admin/dashboard/PalestraReady';
import AdminFGMAutotrasportiDashboard from '@/views/admin/dashboard/FGMAutotrasporti';
import AdminMdMicrodetectorsDashboard from '@/views/admin/picking/ShippingListMdMicrodetectors';
import AdminMatteoRinaldiDashboard from '@/views/admin/dashboard/MatteoRinaldi';

export default {
  name: "adminDashboard",
  components: {
    AdminBormacDashboard,
    AdminSixtenDashboard,
    AdminSelenaDashboard,
    AdminLifestyleDashboard,
    AdminPalestraReadyDashboard,
    AdminFGMAutotrasportiDashboard,
    AdminMdMicrodetectorsDashboard,
    AdminMatteoRinaldiDashboard 
  },
  data() {
    return {
      isBormac: configData.customer == 'Bormac',
      isSixten: configData.customer == 'Sixten',
      isSelena: configData.customer == 'Selena' || configData.customer != 'Bormac' || configData.customer != 'Sixten' || configData.customer != 'Lifestyle' || configData.customer != 'PalestraReady' || configData.customer != 'FGMAutotrasporti' || configData.customer != 'Microdetectors' || configData.customer != 'MatteoRinaldi' ,
      isLifestyle: configData.customer == 'Lifestyle',
      isPalestraReady: configData.customer == 'PalestraReady',
      isFGMAutotrasporti: configData.customer == 'FGMAutotrasporti',
      isMdMicrodetectors: configData.customer == 'Microdetectors',
      isMatteoRinaldi: configData.customer == 'MatteoRinaldi'
    };
  }
}

</script>
